import { gql } from '@apollo/client';

export const GET_WORKSHIFT_MONEY = gql`
  query getWorkShiftPaymentOverviewData($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      id
      total
      cash
      card
      deposit
      online_deposit
      bonus
      refunded
      cash_on_start
      sum {
        good
        service
        tariff
        deposit
        tips
      }
      created_at
      finished_at
      cash_orders {
        type
        sum
      }
      worker {
        uuid
        nickname
        first_name
        middle_name
        last_name
        avatar_url
        roles {
          alias
        }
        phone
      }
    }
  }
`;
